export enum NotificationStatuses {
  DeclinedPending = 'declined_pending',
  Viewed = 'viewed',
}

export enum DistributionMethod {
  Upload = 'upload',
  Bulk = 'bulk',
  BulkMatched = 'bulk_match',
}

export type LogTypes = 'status_changed' | 'file_updated'
